/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Ptw100CsoPortalServiceUnavailableException } from './Ptw100CsoPortalServiceUnavailableException';
import {
    Ptw100CsoPortalServiceUnavailableExceptionFromJSON,
    Ptw100CsoPortalServiceUnavailableExceptionFromJSONTyped,
    Ptw100CsoPortalServiceUnavailableExceptionToJSON,
} from './Ptw100CsoPortalServiceUnavailableException';

/**
 * 
 * @export
 * @interface ErrorResponseOfPtw100CsoPortalServiceUnavailableException
 */
export interface ErrorResponseOfPtw100CsoPortalServiceUnavailableException {
    /**
     * This code is used in the ExceptionMiddleware and will be set as the HTTP response status code
     * @type {number}
     * @memberof ErrorResponseOfPtw100CsoPortalServiceUnavailableException
     */
    readonly httpStatusCode?: number;
    /**
     * 
     * @type {Ptw100CsoPortalServiceUnavailableException}
     * @memberof ErrorResponseOfPtw100CsoPortalServiceUnavailableException
     */
    exception: Ptw100CsoPortalServiceUnavailableException;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseOfPtw100CsoPortalServiceUnavailableException
     */
    $type?: ErrorResponseOfPtw100CsoPortalServiceUnavailableExceptionTypeEnum;
}


/**
 * @export
 */
export const ErrorResponseOfPtw100CsoPortalServiceUnavailableExceptionTypeEnum = {
    PtwPtw100WebSharedModelsErrorResponseErrorResponse1PtwPtw100AppZeroApplicationSharedExceptionsPtw100CsoPortalServiceUnavailableExceptionPtwPtw100AppZeroApplicationSharedPtwPtw100WebShared: 'Ptw.Ptw100.Web.Shared.Models.ErrorResponse.ErrorResponse`1[[Ptw.Ptw100.AppZero.Application.Shared.Exceptions.Ptw100CsoPortalServiceUnavailableException, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.Web.Shared'
} as const;
export type ErrorResponseOfPtw100CsoPortalServiceUnavailableExceptionTypeEnum = typeof ErrorResponseOfPtw100CsoPortalServiceUnavailableExceptionTypeEnum[keyof typeof ErrorResponseOfPtw100CsoPortalServiceUnavailableExceptionTypeEnum];



/**
 * Check if a given object implements the ErrorResponseOfPtw100CsoPortalServiceUnavailableException interface.
 */
export function instanceOfErrorResponseOfPtw100CsoPortalServiceUnavailableException(value?: unknown): value is ErrorResponseOfPtw100CsoPortalServiceUnavailableException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ErrorResponseOfPtw100CsoPortalServiceUnavailableExceptionTypeEnum)[0];
}

export function ErrorResponseOfPtw100CsoPortalServiceUnavailableExceptionFromJSON(json: any): ErrorResponseOfPtw100CsoPortalServiceUnavailableException {
    return ErrorResponseOfPtw100CsoPortalServiceUnavailableExceptionFromJSONTyped(json, false);
}

export function ErrorResponseOfPtw100CsoPortalServiceUnavailableExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorResponseOfPtw100CsoPortalServiceUnavailableException {
    if (json == null) {
        return json;
    }
    return {
        
        'httpStatusCode': json['httpStatusCode'] == null ? undefined : json['httpStatusCode'],
        'exception': Ptw100CsoPortalServiceUnavailableExceptionFromJSON(json['exception']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ErrorResponseOfPtw100CsoPortalServiceUnavailableExceptionToJSON(value?: Omit<ErrorResponseOfPtw100CsoPortalServiceUnavailableException, 'httpStatusCode'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'exception': Ptw100CsoPortalServiceUnavailableExceptionToJSON(value['exception']),
        '$type': value['$type'],
    });
}

